import Hero from "./pages/Hero";
import UnlockThePower from "./pages/UnlockThePower";
import UnmatchedProtocol from "./pages/UnmatchedProtocol";
import Solution from "./pages/Solution";
// import Protocols from "./pages/Protocols";
import Assets from "./pages/Assets";
import Banner from "./pages/Banner";
import Header from "./components/layout/Header/Header";
import Footer from "./components/layout/Footer/Footer";
import {Partners} from "./pages/Partners";
import {useEffect, useState} from "react";
import {getTVLData} from "./lib/axios/tvl";
import {ClipLoader} from "react-spinners";

function App() {
    const [tvl, setTvl] = useState();
    const [loadingTvl, setLoadingTvl] = useState(true);

    useEffect(() => {
        getTVLData().then((res) => {
            setTvl(res.totalValueLocked)
        }).catch(error => {
            console.error("Error fetching TVL data:", error);
            setTvl(null);
        }).finally(() => {
            setLoadingTvl(false);
        })
    }, []);

    if (loadingTvl) {
        return (
           <div className="h-screen flex flex-col justify-center items-center gap-5">
               <ClipLoader
                   size="40"
                   color="#000"
               />
           </div>
        );
    }

    return (
        <div>
            <Header/>
            <Hero tvl={tvl}/>
            <UnlockThePower/>
            <UnmatchedProtocol/>
            <Solution/>
            {/*<Protocols/>*/}
            <Assets/>
            <Partners/>
            <Banner/>
            <Footer/>
        </div>
    );
}

export default App;
